import common from './features/common.slice';
import permissions from './features/permissions.slice';

export const slices = {
    common,
    permissions,
};